<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
      <h1>{{ welcomeMessage }}</h1>
      </div>
    </v-app-bar>

    <v-main>
      <main-page/>
    </v-main>
  </v-app>
</template>

<script>
import mainPage from './components/mainPage.vue'

export default {
  name: 'App',

  components: {
    mainPage,
  },
  data: () => ({
    welcomeMessage: 'Welcome to ' + window.location.hostname.replace(/^www\./, '')
    //
  }),
};
</script>
